import { IArticleDetail } from 'shared/models/article/article';
import { Region } from '@lemon8/web-app-shared/i18n';
import { IArticleUnavailableDetail } from './article-unavailable';
import { ArticleJsonLDUtil } from 'shared/models/article/json-ld-util';

export const ArticleDetailUtil = {
  isArticleAvailable: (article: IArticleUnavailableDetail | IArticleDetail): article is IArticleDetail => {
    return !('unavailableReason' in article);
  },
  /**
   * article has translated version
   */
  hasTranslatedVersion: (article: IArticleDetail): boolean => {
    const { translatedRegions = [] } = article;
    return translatedRegions.length !== 0;
  },
  /**
   * article is translated, and translated version is needed to show
   */
  isTranslatedArticleToShow: (article: IArticleDetail, _region: Region): boolean => {
    const { isTranslatedVersion = false } = article;
    return isTranslatedVersion;
  },

  /**
   * get canonical Article URL in created region
   */
  getOriginalArticleCanonicalUri: (article: IArticleDetail): string => {
    return `/${article.author.linkName}/${article.groupId}?region=${article.articleRegion}`;
  },

  /**
   * get canonical Article URL in current page region
   */
  getCurrentArticleCanonicalUri: (article: IArticleDetail, region: string): string => {
    return `/${article.author.linkName}/${article.groupId}?region=${region}`;
  },

  JsonLD: ArticleJsonLDUtil,
};
